import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Complisense brand logo: document with checkmark (compliance / legal proof).
 * Same icon as upload-proof.html. Use variant="icon" for app bar, variant="wordmark" for logo + text.
 */
const ComplisenseLogoIcon = ({ size = 36, sx = {}, ...rest }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      flexShrink: 0,
      ...sx
    }}
    {...rest}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Document with check – compliance / legal proof */}
      <path
        d="M22 6H12a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V14l-10-8z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22 6v8h8"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 24l3 3 6-6"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Box>
);

/**
 * Full brand block: icon + "Complisense" wordmark.
 */
export function ComplisenseLogo({
  variant = 'wordmark',
  size,
  iconSize,
  href,
  sx = {},
  typographySx = {},
  ...rest
}) {
  const iSize = iconSize ?? (size === 'small' ? 32 : size === 'large' ? 52 : 40);
  const content = (
    <Box
      component={href ? 'a' : 'span'}
      href={href}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1.25,
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': href ? { opacity: 0.92 } : {},
        ...sx
      }}
      {...rest}
    >
      <ComplisenseLogoIcon size={iSize} />
      {variant !== 'icon' && (
        <Typography
          component="span"
          variant={size === 'small' ? 'subtitle1' : size === 'large' ? 'h5' : 'h6'}
          sx={{
            fontFamily: '"Plus Jakarta Sans", "Inter", system-ui, sans-serif',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
            ...typographySx
          }}
        >
          Complisense
        </Typography>
      )}
    </Box>
  );
  return content;
}

export default ComplisenseLogo;
